/**
 * Stockage des observations (sightings).
 *
 * Pour l'instant : localStorage (mode anonyme, pas besoin de compte).
 * Plus tard : Supabase quand l'auth sera en place.
 *
 * Format stocké :
 * {
 *   "<species_id>": { status: "seen" | "skipped" | "doubt", at: ISO_string, region: "mediterranee" }
 * }
 */

const STORAGE_KEY = 'census.sightings.v1';

function loadAll() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

function saveAll(data) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (err) {
    console.warn('[sightings] localStorage indisponible :', err);
  }
}

/**
 * Enregistre une observation.
 * @param {string} speciesId
 * @param {'seen'|'skipped'|'doubt'} status
 */
export function recordSighting(speciesId, status, meta = {}) {
  const all = loadAll();
  all[speciesId] = {
    status,
    at: new Date().toISOString(),
    ...meta,
  };
  saveAll(all);
}

/**
 * Supprime une observation (ex : pour annuler un swipe).
 */
export function undoSighting(speciesId) {
  const all = loadAll();
  delete all[speciesId];
  saveAll(all);
}

/**
 * Retourne le statut pour une espèce, ou null si jamais swipée.
 */
export function getSighting(speciesId) {
  return loadAll()[speciesId] ?? null;
}

/**
 * Compte les observations par statut.
 */
export function countSightings() {
  const all = loadAll();
  const counts = { seen: 0, skipped: 0, doubt: 0, total: 0 };
  for (const entry of Object.values(all)) {
    counts[entry.status] = (counts[entry.status] || 0) + 1;
    counts.total++;
  }
  return counts;
}

/**
 * Retourne tous les IDs d'espèces déjà swipées (peu importe le statut).
 */
export function getSwipedIds() {
  return new Set(Object.keys(loadAll()));
}

/**
 * Retourne l'observation la plus récente (statut "seen" ou "doubt"), ou null.
 * @returns {{ speciesId: string, status: string, at: string }|null}
 */
export function getLatestSighting() {
  const all = loadAll();
  let latest = null;
  for (const [speciesId, entry] of Object.entries(all)) {
    if (entry.status === 'skipped') continue;
    if (!latest || entry.at > latest.at) {
      latest = { speciesId, ...entry };
    }
  }
  return latest;
}

/**
 * Réinitialise tout (pour le bouton "recommencer").
 */
export function resetAllSightings() {
  saveAll({});
}
